import type { ResponsiveOptions } from './types'
import { twHidden } from './style/hidden'
import { twBlock } from './style/block'

/**
 * A function which can take either an object or a string
 * and return a string with correct css classnames. Keys of
 * the object ('sm', 'md', 'lg') can have a boolean value
 * or a string value.
 *
 * @param {object | boolean} hiddenOptions - A object parameter
 * or string
 * @return {string} A string with correct css classnames
 *
 * @example
 * getGapClasses({ sm: true, md: false, lg: true })
 * // => 'ds-hidden md:ds-block lg:ds-hidden'
 *
 */
export const getHiddenClasses = (
  hiddenOptions: ResponsiveOptions | boolean
) => {
  switch (typeof hiddenOptions) {
    case 'boolean': {
      const option = hiddenOptions
        ? twHidden?.default?.sm
        : twBlock?.default?.sm
      return option
    }
    case 'object': {
      const hiddenClasses = new Array<string>()
      Object.keys(hiddenOptions).forEach((key) => {
        if (hiddenOptions[key as keyof typeof hiddenOptions] as boolean) {
          const selectedSize = twHidden[key as keyof typeof twHidden]
          const selectedOption =
            selectedSize && selectedSize[key as keyof typeof selectedSize]
          selectedOption && hiddenClasses.push(selectedOption as string)
        } else {
          const selectedSize = twBlock && twBlock[key as keyof typeof twBlock]
          const selectedOption =
            selectedSize && selectedSize[key as keyof typeof selectedSize]
          selectedOption && hiddenClasses.push(selectedOption as string)
        }
      })
      return hiddenClasses.filter(Boolean).join(' ')
    }
    default:
      return 'default'
  }
}
